import { inject, injectable, interfaces } from 'inversify';
import moment from 'moment';
import { ACDLError } from '../../../../../__legacy__/models/error.model';
import { IMainApiService, MainApiService } from '../../../../../__legacy__/services/api.service';
import { TimePeriod } from '../../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';
import { IProjectStats } from '../models/ProjectStats';

export class GetProjectStatsRequest {
  projectId: string;
  timePeriod: TimePeriod;
  startDate: moment.Moment;
  endDate: moment.Moment;

  constructor(projectId: string, timePeriod: TimePeriod, startDate: moment.Moment, endDate: moment.Moment) {
    this.projectId = projectId;
    this.timePeriod = timePeriod;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export interface IGetProjectStatsService {
  getStatsAsync: (request: GetProjectStatsRequest) => Promise<IProjectStats>;
}

export namespace IGetProjectStatsService {
  export const $: interfaces.ServiceIdentifier<IGetProjectStatsService> = Symbol('GET_STATS_SERVICE');
}

@injectable()
export class GetProjectStatsService implements IGetProjectStatsService {
  constructor(@inject(IMainApiService.$) private readonly apiService: MainApiService) {}

  getStatsAsync = async (request: GetProjectStatsRequest): Promise<IProjectStats> => {
    const searchParams = new URLSearchParams({
      projectId: request.projectId,
      timePeriod: request.timePeriod.toString(),
      startDate: request.startDate.format(),
      endDate: request.endDate.format(),
    }).toString();

    const response = await this.apiService.getAsync<IProjectStats>(`/projects/ProjectStats?${searchParams}`);

    if (response instanceof ACDLError) {
      throw response;
    }

    return response;
  };
}
